class EventSystem {
  constructor(index) {
    this.events = {}
  }

  on(event, callback = (...params) => {}) {
    if (!this.events[event]) {
      this.events[event] = []
    }
    this.events[event].push(callback)
  }
  off(event, callback = (...params) => {}) {
    if (this.events[event]) {
      const index = this.events[event].indexOf(callback)
      if (index !== -1) {
        this.events[event].splice(index, 1)
      }
    }
  }

  emit(event, ...params) {
    if (this.events[event]) {
      this.events[event].forEach(ev => {
        ev(...params)
      })
    }
  }
}

export default EventSystem
